module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "chapter-number---IVP sigil_not_in_toc"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page27",
      "title": "27"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor106"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor107"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor108"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor109"
    }
  }), _vm._v("3")]), _vm._v(" "), _c('h2', {
    staticClass: "chapter-title---IVP",
    attrs: {
      "id": "_idParaDest-7",
      "title": "3 Longing and Lament"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor110"
    }
  }), _vm._v("Longing and Lament"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("For God alone my soul waits in silence. . . . For God alone, O my soul, wait in silence.")]), _vm._v(" "), _c('p', {
    staticClass: "epi_source"
  }, [_c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Psalm+62%3A1,+5&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Psalm 62:1, 5")])]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("Psalms of lament allow us to speak from the darkest regions of the heart, where our despair threatens to overwhelm us. In so speaking we do not exhibit a lack of faith, but stand in a biblical tradition that recognizes that no part of life, including the most hideous and painful parts, is to be withheld from God, who loves us, who in Jesus Christ speaks the psalms of lament alongside us, and who proclaims hope, when there can—at least for the time being—be no hope in us. The Church would do well to recover this biblical practice of lamentation.")]), _vm._v(" "), _c('p', {
    staticClass: "epi_source"
  }, [_vm._v("Nancy J. Duff, “Recovering Lamentation as a Practice in the Church”")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("Man who is born of a woman is few of days and full of trouble. He comes out like a flower and withers; he flees like a shadow and continues not.")]), _vm._v(" "), _c('p', {
    staticClass: "epi_source"
  }, [_c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Job+14%3A1-2&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Job 14:1-2")])]), _vm._v(" "), _c('p', {
    staticClass: "dingbat"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/dingbat_c.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page28",
      "title": "28"
    }
  }), _c('span', {
    staticClass: "first-words"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor111"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor112"
    }
  }), _vm._v("Human history is a story")]), _vm._v(" of incomprehensible joy, stunning accomplishments, and life-giving relationships. But it is also a story of tedious days, devastating diseases, and broken bodies. We can walk on the moon, yet we have no words, no strength, and no answers for parents who have just learned that their child has leukemia. Life seems to have more deep valleys and long desert roads than shady alleys or grand boulevards. Physical limits, disease, heartbreak, and ultimately death come to all.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Our lives have both light and darkness, both magnificence and brokenness, but we are inclined to see only one side at any given time. When we are up, we neglect to consider our times of anguish; when we experience intense suffering, it is easy to see only darkness. Thus, those who are in a period of relative comfort can find it very difficult to connect with the grief of those around them, and indeed the well-being of a neighbor can deepen the grief of someone in pain. Life is not simply pain, but this life inevitably includes suffering, and to imagine otherwise is to flirt with the fantastical rather than to face the real.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In large part our deep longing is for rich and nourishing peace—what the ancient Hebrews called "), _c('i', [_vm._v("shalom")]), _vm._v("—which makes our present suffering so difficult to bear. Not only do we have to suffer the pain itself but also the knowledge and frustration of its wrongness. So the world is not as it should be. It is "), _c('i', [_vm._v("not")]), _vm._v(" “good.” We know that harmony between people, between humanity and the land, between our heads and hearts, between heaven and earth is not just an object of our desire but is good and true. This knowledge adds a bitterness to the brokenness of the world, emphasizing the difference between our expectations of the good and our experience of its absence. This sometimes results in relational breakdown as well. How often have marriages fallen apart after a grave illness strikes a child, or once vibrant friendships turned cold after one person is no longer able to be as active as the other?")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("This common human craving for shalom frequently surfaces most intensely in our darkest hours. Some claim such yearnings are simply wish projections we create, hopes cultivated to keep us sane while we suffer. Yet such a cynical view of human futility leaves us all open to despair, not just when we suffer but even when things are going well. Is there really no difference between shalom and chaos, between pain and relief? People all around the world and throughout history have not found it so hard to "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page29",
      "title": "29"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor113"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor114"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor115"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor116"
    }
  }), _vm._v("imagine that the human creature has a purpose, a "), _c('i', [_vm._v("telos")]), _vm._v(". The genuine tastes of harmony and grace we sometimes experience appear to point beyond us to a larger narrative.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("When we express our longing for lasting shalom but also confess its current transitory nature, a compelling story develops, one that makes sense of love and yearning without doing violence to the complexity of the current human condition. Rejecting both utopianism on the one hand and despair on the other leads us to what might be called defiant hope.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Love in this life inevitably involves suffering. Some people, realizing this, harden their hearts or choose some form of self-destruction. For example, couples who go through repeated miscarriages often struggle with crushing grief and disappointment. Sometimes people suggest that they not get their hopes up lest they be devastated yet again. “Protect your hearts,” they are told. Yet protecting their heart only means that they steel it against hope and joy and make it fit to feel only disappointment and pain. That is calling them not to life but to death—such suggestions require them to slowly kill off their heart. So they risk, they yearn, they long, and they struggle. Why? Because they dare to love. Most who truly love others will at some point have their hearts join the chorus of lament in the human drama.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_8"
    }
  }, [_vm._v("The Necessity of Lament")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Laments rise to the heavens as a strange combination of complaint, grief, questions, confusion, desire for rescue, and expectation of divine faithfulness. Our great hope is that lament is not "), _c('i', [_vm._v("all")]), _vm._v(" there is to human experience. Nevertheless, any who have truly lived and loved must come to believe that lament is at least part of our existence. Only the idealistic and unloving belittle tears and sadness. Only the coolly detached never raise a complaint about the condition of things, including our broken bodies. If we never lament, then it is legitimate to wonder if we have ever truly loved. Biblically we discover that lament is a legitimate, even necessary, form of fellowship with God when we are in a place of pain. The Bible repeatedly affirms lament to be an honest and expected expression of our battle with the brokenness of ourselves and the rest of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Our background, however, often inclines us to be uncomfortable with lament and mourning. This discomfort comes from various contributions "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page30",
      "title": "30"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor117"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor118"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor119"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor120"
    }
  }), _vm._v("of Western civilization and not from the Scriptures. Even when we face death, the last enemy, we in the West can reject expressions of grief at memorials as excessive or sacrilegious. Some even go so far as to call funerals “celebrations” and encourage people not to wear black."), _c('a', {
    attrs: {
      "id": "_idTextAnchor121"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1534",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("1")])]), _vm._v(" Even those without any faith commitments occasionally speak of transcendent peace, future reunions, “better places,” and new realms of love."), _c('a', {
    attrs: {
      "id": "_idTextAnchor122"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1535",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("2")])]), _vm._v(" Well-meaning Christians sometimes suppress their dark anguish because of their belief in heaven, as if mourning and biblical hope were necessarily at odds, despite the historical Christian affirmation of the place of lament. As one of my self-described “bicultural” Christian friends explained, he really “prefers the Korean version of funerals and memorials to American ones. Wailing and heavy drinking seem much more in accord with what is happening inwardly.” Many agree with his sentiment. One day while my wife and I lived overseas, we were walking home and heard the harrowing cries of those outside a hospital, wailing over the death of a loved one. Though there was some reason to believe these mourners were Christians, this was their response, culturally accepted and even expected. Our cultural sensibilities were shocked, but on reflection it seems a truer reflection of the soul’s cry against the robber named Death. A simple verse telling them not to mourn like unbelievers will not do. Christians are different because of our hope in Christ, who has overcome death. But death is still an enemy, so grief and mourning are an appropriate and realistic response to the loss of the presence of our loved ones. We weep with those who weep.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("While conducting his mother’s funeral a number of years ago, Pastor Eugene Peterson was so overcome with the ugliness and pain of death that he broke down and wept uncontrollably in front of those who were gathered there. After finishing the service, he went into a side room in order to settle himself. His daughter also came and sat with him, crying and lamenting along with him. A few moments later a man he did not know entered the room and sat down next to him. He placed his arm around Peterson, muttered some “preacherish clichés” in a “preacherish tone” and then stepped out, seemingly confident that his platitudes had properly consoled this distraught man. After his unsolicited comforter had left, Peterson leaned over to his daughter and said, “I hope I’ve never done that to anybody.” His daughter reassured him that he had not."), _c('a', {
    attrs: {
      "id": "_idTextAnchor123"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1550",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page31",
      "title": "31"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor124"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor125"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor126"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor127"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor128"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor129"
    }
  }), _vm._v("To have healthy fellowship with God we must be honest and realistic about our circumstances and our reactions to them. To have a healthy emotional, spiritual, and mental life, we must be honest with ourselves. One truth about our lives is that we are broken; we inevitably encounter our own suffering and that of others, and eventually we die. How does our Lord teach us to respond to this? He teaches us hope, and within that hope we use lament to speak to God of the painful delay of peace. All laments ultimately go to God, with whom we wrestle and rest.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Unfortunately, this tendency to downplay lament has been the experience of an ever-growing number of people. Perhaps it is has been your experience. The real problem is that this devaluing of lament often betrays our failure to admit that our suffering is real and painful. Our failure to practice lament during such times may also display our inability to recognize that what happens to our bodies also affects our relationships.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The human experience requires lament, at least as long as we live in the current world as we know it."), _c('a', {
    attrs: {
      "id": "_idTextAnchor130"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1551",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("4")])]), _vm._v(" Biblically there can be no question about the place and need of this practice—sin and sickness mean we must create space for genuine lamentation. Not because we despair but because we recognize the wounds of this world and of our hearts. God instructs us to bring to him our tears, our hurts, our confusion. Old Testament scholar Daniel J. Simundson reminds us of this scriptural tradition:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("The lament allows for honest interchange between humans and God, the freedom to admit even bad theology and hostile thoughts. The lament turns to God as the ultimate source of help and, in the typical lament form, ends with the assurance that God has heard and will save. The lament does not solve all of the sufferer’s intellectual questions about the origin and meaning of the suffering, but does provide a structured way for the faithful to bring their suffering to God’s attention and to cope with it."), _c('a', {
    attrs: {
      "id": "_idTextAnchor131"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1552",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("If we do not restore space for lament in our individual and corporate church life, our suffering will drive us not only away from others but away from God himself.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In contrast with frequent Western practice, the New Testament narratives in which physical death occurs exhibit intense lament and tears, even from Jesus. Hope does not rule out the need for mourning in our lives but rather "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page32",
      "title": "32"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor132"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor133"
    }
  }), _vm._v("demands it, because our hope itself tells us that our brokenness is wrong. Hope does not cause the widow to cease missing the warmth of her beloved lying next to her each night in bed. Hope does not answer all of our questions. Christian hope does "), _c('i', [_vm._v("not")]), _vm._v(" mean a cessation of lament, since these two often go together. We imagine this as a linear relationship, in which a person experiences sadness for a time and then graduates to hope (the binary option). Not so. Or we imagine that the heart is a set of scales with pain and suffering on one side and faith and hope on the other. The lamenter may be told that if they add more hope and faith, these things outweigh the darkness and tip the scales (see fig. 1). Such imagery is not only unhelpful, it is wrong and does violence against the souls of those who suffer. It has no place in the church.")]), _vm._v(" "), _c('div', {
    staticClass: "photo90"
  }, [_c('img', {
    staticClass: "img100",
    attrs: {
      "alt": "",
      "src": "Images/5179_figure1_4C.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption_fig"
  }, [_c('b', [_vm._v("Figure 1.")]), _vm._v(" Common binary option")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We struggle and mourn not only at the presence of death but also in response to its far-reaching effects. Grieving often arises as we deal with debilitating sickness, when bouts with mental illness create unnerving chaos and unsettle established relationships, or as chronic pain becomes the unwelcome companion of those we love. To mourn, whether over the broken­ness of our bodies or over the injustices of this world, is not simply an option but an obligation."), _c('a', {
    attrs: {
      "id": "_idTextAnchor134"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1553",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("6")])]), _vm._v(" Going through chemotherapy or the treatment of an autoimmune disease, the believer may consistently oscillate between lament and hope, with neither canceling the other out. In fact, people testify to moments when both joyful hope and jarring grief are simultaneously present. Often they dwell together in our hearts as strange bedfellows (see fig. 2). Such emotional complexity is partly what can be so difficult on marriages and friendships, since it is not always easy for the caregiver to relate to the hurting one amid their turbulence. In the psalms, lamentations often carry hope within them, but they remain heartrending expressions of crying out to God. Mourning is a Christian practice: blessed are those who mourn. Yet we do not simply mourn, but we lament, for in our lamentations we ask deep questions, face darkness, voice our frustrations, and cling to unrealized promises. My family has been part of a multiracial and intentionally crosscultural church. The worship style of this church is strongly influenced by "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page33",
      "title": "33"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor135"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor136"
    }
  }), _vm._v("African American gospel traditions. This worship style is a good example of deep lament that never loses its hold on Christ and hope. It affirms that hope cannot be seen and felt unless brokenness and pain are recognized first.")]), _vm._v(" "), _c('div', {
    staticClass: "photo90"
  }, [_c('img', {
    staticClass: "img100",
    attrs: {
      "alt": "",
      "src": "Images/5179_figure2_4C.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption_fig"
  }, [_c('b', [_vm._v("Figure 2.")]), _vm._v(" The hope-lament quadrant")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("When we choose not to lament, we harden our hearts. When we claim that the problems in this life are illusory, when we act as if all the wrongs from our physical pains or horrific injustices are insignificant—in short, when we try to wall ourselves off from suffering, we also wall ourselves off from others and from the God who tells us that this pain is a real, if temporary, fight that requires our attention. While certain stoic forms of spirituality encourage us to “accept,” that has not actually been the Christian confession throughout the ages. Not all is good in this world. God, in his sovereignty, has recruited us into his war against darkness and death, and lament brings us back to our dependence on him in that fight. This lament does not undercut divine authority and care but rather beseeches the presence and comfort of God into the most wounded parts of our souls. Here I think of Carrie, who wrote an extended narrative to me a few years after losing her child in a most painful and devastating miscarriage. Even years after the devastating experience, she described the grace of lament in her life: “God fills up my emptiness with the promise of his presence. I was "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page34",
      "title": "34"
    }
  }), _vm._v("not and am never left alone in my lament.” Lament takes one to our Father, and only in him can we discover hope in the midst of our most painful fears and frustrations.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Bob, a dear friend in his late fifties, asked if he might audit the class I was starting in a few days on faith and suffering."), _c('a', {
    attrs: {
      "id": "_idTextAnchor137"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1554",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("7")])]), _vm._v(" Here was a faithful saint, elder, and pillar in his local church. To give you a sense of this man’s heart, he once took a significant demotion at work in order to be able to spend more time with his wife and caring for members of the church. But he also had known real pain of various sorts in his life. He and his wife had spent years and years caring for elderly parents, and it had not gone smoothly. As you make your wedding vows, he once told me, you don’t think about changing your mother-in-law’s diapers. But love does such things. I knew there were painful family disappointments and struggles.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Even though his “pain” had not primarily been his own physical suffering, Bob explained to me that he hoped it would be okay to be in the class. Obviously I was honored to have him join us. About a month into class we took time to write personal laments. This is not an easy exercise, and it can be deeply painful. Sitting outside under the warm sun, students scattered about looking out over the Georgia valley from Lookout Mountain. Bob sat and started writing. About forty minutes later he came to me and handed me notes on a scribbled paper. He later gave me permission to share with you. Here is his “A Spontaneous Lament,” which functions as a back and forth with his God:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_vm._v("Why did my daughter’s husband break her heart?")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("I know, little child")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Won’t you tell me, Father?")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("I won’t, my son")]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_vm._v("Why does my wife have to live in pain?")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("I know little child")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Won’t you tell me, Father? It would make it easier")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("It wouldn’t, my son")]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_vm._v("Why do parents have to bury their children? It isn’t right")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("It isn’t, little child")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Then get rid of death, Father")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("I am, my son")]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page35",
      "title": "35"
    }
  }), _vm._v("Why are your people abused, persecuted and killed? Can’t you protect them?")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("I can, little child")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Then do something")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("I did, my son")]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_vm._v("Why do my parents need to finish their lives in unrelenting misery? How is that merciful?")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("It is, little child")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Then I don’t understand mercy")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("You don’t, my son")]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_vm._v("But it all hurts so much sometimes")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("I know it does, little child")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("How do you know Father?")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("I have felt all the pain of sin, my son")]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_vm._v("Can’t you make it all stop?")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("I can, little child")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Then do it, Father")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("I started 2000 years ago and will finish soon, my son")]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_vm._v("I believe you, Father, help my unbelief")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("I love you, my son")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Here Bob poured out his heart to our Father, who did not answer all his questions but took him to his Son. About three weeks after Bob wrote this lament, he got a call from his doctor while he was sitting at a Mr. T’s Pizza Parlor. “Don’t eat another bite,” the physician asserted. In the following weeks Bob was diagnosed with pancreatic cancer. Now the pain was not his wife’s or his daughter’s, or anyone else’s, but his own. I have watched Bob and his wife walk through this frightening time with courage and humor but also with a willingness to lament. This is not because they lack faith but because their faith is so real, so personal, so intimate. Where else can we turn with our questions, hurts, concerns, and longings? No one but the living God can fully handle our lamentations.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_9"
    }
  }, [_vm._v("The Shape of Our Laments")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("God’s good creation has been compromised, and to act as if it hasn’t is offensive to the truthfulness of God. Not all is well in the land of the living. Yes, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page36",
      "title": "36"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor138"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor139"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor140"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor141"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor142"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor143"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor144"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor145"
    }
  }), _vm._v("there is a danger of becoming so absorbed with our grief that we are tempted to believe there is nothing more than lament. I will speak of this later, but before I so quickly warn against endless despair, let’s learn to allow our hearts and our communities the space to honestly struggle and ache before God and others. The songs of lament, which make up over 40 percent of the psalter, remind us that we can bring our questions and struggles to God himself. Consider some of the verses from "), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Psalm+88&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Psalm 88")]), _vm._v(":")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_vm._v("O Lord, God of my salvation;")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("I cry out day and night before you . . .")]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_vm._v("For my soul is full of troubles,")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("and my life draws near to Sheol.")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("I am counted among those who go down to the pit;")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("I am a man who has no strength,")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("like one set loose among the dead,")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("like the slain that lie in the grave,")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("like those whom you remember no more,")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("for they are cut off from your hand. ("), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Ps+88%3A1-5&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Ps 88:1-5")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Elsewhere such ache is vividly portrayed: ")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_vm._v("My tears have been my food ")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("day and night, ")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("while they say to me continually, ")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("“Where is your God?” ("), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Ps+42%3A3&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Ps 42:3")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Jeanette Mathews, building on the work of those in the visual arts, argues that the idea of “framing” can help us better understand the place and practice of lament in the life of the people of God."), _c('a', {
    attrs: {
      "id": "_idTextAnchor146"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1555",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("8")])]), _vm._v(" Mathews’s “framing” functions like an actual frame used to hold a painting. Three things occur in this event. First, the frame "), _c('i', [_vm._v("constrains")]), _vm._v(" the artwork, actually setting limits or a boundary for the painting. This far and no further! The artwork cannot take over the house even as it is welcome to inhabit a space within the home. Second, the framing "), _c('i', [_vm._v("heightens")]), _vm._v(" our awareness of what we should be concentrating on and thus directs our contemplation. In this way the art is contrasted with what might be called normal life or the regular environment, as if the art takes us by the shoulders and shakes us awake, forcing us to look "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page37",
      "title": "37"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor147"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor148"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor149"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor150"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor151"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor152"
    }
  }), _vm._v("at what is right in front of our eyes. Without such a heightening of our senses, we risk becoming insensitive to what is all around us, including the presence of others and how they might be seeing the world. Third, the frame "), _c('i', [_vm._v("clarifies")]), _vm._v(" by helping to shape how we see the piece of art. We are drawn in, we focus, and then we see afresh.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Similarly, biblical laments offer a guide for our experiences. An ancient pattern is found in these biblical laments, encouraging us to actively cry out to God rather than merely become passively absorbed by the pain. Although not always proceeding in a neat fashion, the following elements are common in lament psalms:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("A cry out to God: “My God, My God, why have you forsaken me?”")]), _vm._v(" "), _c('li', [_vm._v("A complaint or voicing of the crisis that drives the poem: “Why are you so far from saving me, from the words of my groaning? . . . All who see me mock me.”")]), _vm._v(" "), _c('li', [_vm._v("A petition in which remedy is yearned for: “Be not far from me, for trouble is near, and there is none to help.”")]), _vm._v(" "), _c('li', [_vm._v("Often (though not always!) a claim of confidence in God: “All the ends of the earth shall remember and turn to the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(".”")]), _vm._v(" "), _c('li', [_vm._v("Often (though not always!) a commitment to praise God: “I will tell of your name to my brothers; in the midst of the congregation I will praise you.”"), _c('a', {
    attrs: {
      "id": "_idTextAnchor153"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1556",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("These poems and songs often contain elements of protest, frustration with God, or anger about the presence of injustice or ongoing suffering. Concern at God’s lack of response is also common, sometimes wondering if God has nodded off (“Awake! Why are you sleeping, O Lord? Rouse yourself!” ["), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Ps+44%3A23&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Ps 44:23")]), _vm._v("]). At other times, echoing the prayers of leaders like Moses (e.g., "), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Ex+32%3A11-14&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Ex 32:11-14")]), _vm._v("), some lamentations debate with God, piling up arguments as if to convince Yahweh why action should be taken. Does Moses or the psalmist fail to believe in the sovereignty of God? Do they imagine somehow that God has limited cognitive functions and easily forgets? Certainly not. And yet they lament and wrestle with God. For these biblical leaders, God’s presence and power does not eliminate their struggle but rather provides the ultimate context for it. In her reflections on the book of Lamentations, Kathleen O’Connor captures how these varied yet accepted patterns of wrestling with God serve the faithful:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page38",
      "title": "38"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor154"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor155"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor156"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor157"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor158"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor159"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor160"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor161"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor162"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor163"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor164"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor165"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor166"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor167"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor168"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor169"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor170"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor171"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor172"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor173"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor174"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor175"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor176"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor177"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor178"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor179"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor180"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor181"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor182"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor183"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor184"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor185"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor186"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor187"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor188"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor189"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor190"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor191"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor192"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor193"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor194"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor195"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor196"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor197"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor198"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor199"
    }
  }), _vm._v("The point of lamenting is not to confess sin . . . but to name injustice, hurt, and anger. . . . Laments empower sufferers to speak for themselves. . . . Naming suffering before God reclaims human dignity and power that has been trampled and violated. . . . Laments are the beginning of action, a rejection of passivity, and so they can invert despair."), _c('a', {
    attrs: {
      "id": "_idTextAnchor200"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1557",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("These cries do not form a subversive antireligious voice but operate at the heart of the biblical canon among the prayers and songs of the people of God. They are part of their liturgy and worship. Laments are not just for individuals (e.g., "), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Ps+3;+4;+13;+22;+31;+39;+57;+69;+71;+77;+139&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Ps 3; 4; 13; 22; 31; 39; 57; 69; 71; 77; 139")]), _vm._v(") but often reflect the cry of the community. For example, there are at least eleven community laments scattered throughout the Hebrew psalter ("), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Ps+44;+60;+74;+79;+80;+83;+85;+90;+94;+123;+137&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Ps 44; 60; 74; 79; 80; 83; 85; 90; 94; 123; 137")]), _vm._v(")."), _c('a', {
    attrs: {
      "id": "_idTextAnchor201"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1558",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("11")])]), _vm._v(" The psalms not only offer praise to God and acknowledge his goodness but also ask if God has forgotten his people, if he remembers his promises and will yet display his compassion.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("When contemporary churches cease to sing laments as part of their regular catalog of songs, instead only choosing happy or upbeat music, the people of God lose their ability to lament well: our muscles for godly mourning atrophy. We become ill-equipped to handle the pain that life throws at us. Without space for genuine lament, false veneers and bitterness easily take root, eventually bringing destruction in their wake. Suffering surprises and isolates once-active worshipers, often driving them away. When the homes of believers are hit by chronic pain or mental illness, they often find the contemporary church strangely unhelpful, even hurtful. A hurting family no longer fits the American Christian model of growth, happiness, and victory. When the church is robbed of its regular pronouncements, prayers, and songs of lament, then, like a shepherd distracted by the stars in the sky, it fails to protect and nourish the vulnerable sheep entrusted to its care. Rather than receiving special care and protection, the wounded believer is left alone to doubt and despair. The church that responds by entering their lament, however, participates in the healing that the wounded find at the feet of the compassionate Father. There we lay them; there we cry out with them; there we "), _c('i', [_vm._v("together")]), _vm._v(" long for healing and hope.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_10"
    }
  }, [_vm._v("The God of Our Laments")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Mary came to see me because she wanted to talk. The memories, grief, and  ache were too much. She was overwhelmed by her own experiences and by "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page39",
      "title": "39"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor202"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor203"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor204"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor205"
    }
  }), _vm._v("the pain of others she had witnessed firsthand. Having grown up on a Native American reservation, she had seen and known a depth of sadness, despair, and darkness that haunted her many nights. We do not need to get into the details here, but one particular little girl’s troubles were always before Mary. Eventually Mary’s family brought the young girl into their home, cared for her, but also saw up close how painful dysfunction and abuse can be. What was Mary to do? She knew she should lament, but she was finding herself suffocated by all the grief and sadness.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('i', [_vm._v("Sehnsucht")]), _vm._v(" is a German word that people struggle to translate since it means “yearning, craving, or sensing something is profoundly wrong or missing.” Some have noted how built into the idea of "), _c('i', [_vm._v("sehnsucht")]), _vm._v(" is a type of nostalgia; this form of sentimentality includes a feeling that not everything is right in this world, and so we long for another world. As Christians, we believe this feeling of "), _c('i', [_vm._v("sehnsucht")]), _vm._v(" and nostalgia is a longing for shalom.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("As I listened to Mary I wondered what to say, and then it occurred to me. Mary was right: her lament was killing her. Suddenly, pieces of the puzzle began to make sense to me. If you could truly and fully lament, not just for yourself but for the world, it would kill you. Literally. Out of great pain Mary said to me, “I just don’t have the time and energy for the laments. I’ve seen too much sorrow growing up.” She was speaking the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("A full lament is deadly. We know this because when Jesus fully and truly enters into lament, it kills him."), _c('a', {
    attrs: {
      "id": "_idTextAnchor206"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1559",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("12")])]), _vm._v(" He dies. But in his case his lament was not for himself but for others. He enters in so that our laments don’t have to kill us. We will turn to this more in the coming chapters, but for now we need to be honest about the pain of lament and why we are inclined to avoid it. It hurts. And if we fully and completely felt the lament of this broken and sinful world, it would crush any and all of us. We know that because it crushed Jesus. But thanks be to God, this Jesus also rose from the depths of despair and from the grave. He rose and lives even now. For now, let us simply appreciate that we are allowed, even invited, to lament. Yet we must take those laments to God since they will not crush him.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Yahweh can absorb our frustrations; he doesn’t fret before our questions; he is able to respond to our concerns. We must never forget “what ultimately shapes biblical lament is not the need of the creature to cry its woe, but the faithfulness of the God who hears and acts.”"), _c('a', {
    attrs: {
      "id": "_idTextAnchor207"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1560",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("13")])]), _vm._v(" After voicing such laments—"), _c('a', {
    attrs: {
      "id": "_idTextAnchor208"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor209"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor210"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor211"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor212"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor213"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor214"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor215"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor216"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor217"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor218"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor219"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page40",
      "title": "40"
    }
  }), _vm._v("dealing with everything from feelings of betrayal to persecution, from fear of death to a sense of being under judgment—our posture can then be changed. Instead of denying or dismissing the human struggle, lament reminds the worshiper of Yahweh’s extraordinary care. “How precious is your steadfast love, O God! / The children of mankind take refuge in the shadow of your wings” ("), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Ps+36%3A7&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Ps 36:7")]), _vm._v("). One does not need a shelter if there are no threatening elements. Amid violent storms or debilitating heat we become most conscious of our need for sanctuary.")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_vm._v("God is our refuge and strength,")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("a very present help in trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Therefore we will not fear though the earth gives way,")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("though the mountains be moved into the heart of the sea,")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("though its waters roar and foam,")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("though the mountains tremble at its swelling. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("The Lord of hosts is with us;")]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_vm._v("The God of Jacob is our fortress. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Be still, and know that I am God. ("), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Ps+46%3A1-3,+7,+10&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Ps 46:1-3, 7, 10")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Real threats are observed, real dangers swirl about. As part of his theology of the sovereignty of God, the psalmist knows God to be a refuge amid the chaos of struggle, pain, and confusion. Honest lament and mourning can allow us to receive hope and be open to God’s presence in a way that appears impossible without such genuine acknowledgement of the questions and hurt. Again, the psalms give us not philosophical justifications for the presence of evil but instead join us in expressing heartfelt ache and confidence in God’s presence. Hope comes to us not by denying or downplaying our pain but by acknowledging it before the God who abounds with compassion ("), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Is+49%3A13&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Is 49:13")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Lament helps keep us sane amid physical suffering; it allows us to acknowledge real problems even as we hold out for the unrealized resolution. It affirms God’s shalom even as it confesses our present trouble. As we wonder what it means to look to God amid our suffering, the only way we might keep our hope is to keep this larger, complex story of humanity in mind. Powerful, inventive, and delightful creatures that we can be, we also suffer and complain. We are never far from the dueling experiences of splendor and pain, triumph and tragedy. Lament allows us to embrace this "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page41",
      "title": "41"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor220"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor221"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor222"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor223"
    }
  }), _vm._v("tension without being swallowed up by it. It enables us to look for God’s deliverance even as the sandstorm of life threatens and swirls.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We will only discover hope when we are ruthlessly honest about what lies between us and that hope. At least such truth telling is required if we are ever to know the true hope of the ancient Christian confession. The church denies the power of the gospel when it trivializes grief and belittles physical pain, overspiritualizing our existence in such a way as to make a mockery of the Creator Lord. Faithfulness to the gospel requires the Christian community to deal with the messiness of human grief. Biblical faith is not meant to provide an escape from our physical pain or to belittle the darkness of depression and death but rather invites us to discover hope and grace amid our struggle.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("To be a truly human story—which is the only way we should understand the Christian story—means it must confess both grief and hope, sin and faithfulness, struggle and promise. We must learn to be truly honest with ourselves, with others, and even with God. Our theology requires it. Our stories demand it. Only with this kind of confession and lament are we finally in a position to capture a glimpse of the God who is, rather than the god we imagine him to be. Only then can we discover the scandalous grace of God so often spoken about but so seldom truly savored.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Some who experience chronic suffering see God not as a source of hope but of condemnation. Instead of compassion they see only judgment and indifference. What are we to think of God amid our suffering and as we struggle through our laments? It will prove necessary for us to reflect on the fact that humans are embodied, finite, and sinful creatures. Our finitude is not a sin, but the tyranny of sin and brokenness has affected our finitude, and this is especially seen as we experience suffering in our bodies. Only after we start to believe in God’s commitment to us—including to our bodies—will we be ready to speak properly about Jesus. And then, turning to him we will gain not only a better understanding of ourselves but of God himself. What we discover may prove surprising.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page42",
      "title": "42"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4725362","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/11_ch3.vue
// module id = 81
// module chunks = 0